import type { PluginManifest } from "@aspect/plugin-sdk";

/**
 * 内置插件注册清单。
 * 新增内置插件只需在此追加条目，PluginProvider 启动时自动加载。
 */
export const BUILTIN_PLUGINS: Array<{ manifest: PluginManifest; baseUrl: string }> = [
  {
    manifest: {
      name: "主题修改器",
      id: "com.sailwith.theme-modifier",
      version: "1.0.0",
      sdk: "^1.0.0",
      description: "自定义背景图片和主题色",
      author: "SailWith",
      permissions: ["theme:read", "theme:write"],
      toolbar: {
        path: "./index.html",
        title: "修改主题",
        icon: "palette",
        display: "drawer",
        width: 360,
      },
    },
    baseUrl: "/plugins/theme-modifier/",
  },
  {
    manifest: {
      name: "视频播放器",
      id: "com.sailwith.video-player",
      version: "1.0.0",
      sdk: "^1.0.0",
      description: "支持 YouTube 和 Bilibili 视频播放",
      author: "SailWith",
      viewer: {
        path: "./index.html",
        title: "视频播放器",
        icon: "play",
        urlPatterns: [
          "*://www.youtube.com/watch*",
          "*://youtube.com/watch*",
          "*://m.youtube.com/watch*",
          "*://music.youtube.com/watch*",
          "*://youtu.be/*",
          "*://www.bilibili.com/video/**",
          "*://bilibili.com/video/**",
          "*://m.bilibili.com/video/**",
        ],
      },
    },
    baseUrl: "/plugins/video-player/",
  },
  {
    manifest: {
      name: "PDF 阅读器",
      id: "com.sailwith.pdf-reader",
      version: "1.0.0",
      sdk: "^1.0.0",
      description: "在应用内预览 PDF 文件",
      author: "SailWith",
      viewer: {
        path: "./index.html",
        title: "PDF 阅读器",
        icon: "file-text",
        urlPatterns: [
          "*.pdf",
          "*://*/*.pdf",
          "*://*/*.pdf?*",
        ],
      },
    },
    baseUrl: "/plugins/pdf-reader/",
  },
];
